import { writable, derived } from 'svelte/store';
import api from '../services/api.js';

function createPortfolioStore() {
  const { subscribe, set, update } = writable({
    summary: null,
    positions: [],
    history: [],
    loading: false,
    error: null,
  });

  return {
    subscribe,

    async fetchSummary() {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const summary = await api.getPortfolioSummary();
        update(state => ({ ...state, summary, loading: false }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
      }
    },

    async fetchPositions() {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const response = await api.getPositions();
        const positions = response.positions || response || [];
        update(state => ({ ...state, positions, loading: false }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
      }
    },

    async fetchPositionsWithHistory(period = '1M') {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const response = await api.getPositionsWithHistory(period);
        const positions = response.positions || [];
        update(state => ({ ...state, positions, positionsPeriod: period, loading: false }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
      }
    },

    async fetchHistory(period = '1M') {
      update(state => ({ ...state, loading: true, error: null }));
      try {
        const history = await api.getPortfolioHistory(period);
        update(state => ({ ...state, history, loading: false }));
      } catch (error) {
        update(state => ({ ...state, error: error.message, loading: false }));
      }
    },

    async refresh() {
      await Promise.all([
        this.fetchSummary(),
        this.fetchPositions(),
      ]);
    },

    reset() {
      set({
        summary: null,
        positions: [],
        history: [],
        loading: false,
        error: null,
      });
    },
  };
}

export const portfolio = createPortfolioStore();

export const totalValue = derived(
  portfolio,
  $portfolio => $portfolio.summary?.total_value || $portfolio.summary?.equity || 0
);

export const cashBalance = derived(
  portfolio,
  $portfolio => $portfolio.summary?.cash || 0
);

export const buyingPower = derived(
  portfolio,
  $portfolio => $portfolio.summary?.buying_power || 0
);

export const pendingOrders = derived(
  [cashBalance, buyingPower],
  ([$cashBalance, $buyingPower]) => Math.max(0, $cashBalance - $buyingPower)
);

export const dayChange = derived(
  portfolio,
  $portfolio => ({
    amount: $portfolio.summary?.daily_change || 0,
    percent: $portfolio.summary?.daily_change_percent || 0,
  })
);